const api = {
  // localhost: "http://localhost:5003",
  localhost: `http://${location.host}/api-send`
  // localhost: 'http://175.178.71.181:5003'
  // localhost: 'http://192.168.3.218:5003'
};

export default api;
